import moment from 'moment';
import momentTZ from 'moment-timezone';
// make sure needed locales are included in the bundle (en-us is default)
import 'moment/locale/en-gb';
const supportedLocales = ['en-gb', 'en-us'];
const getClientPreferredLocale = () => {
    const preferredLocale = navigator.language.toLowerCase();
    return supportedLocales.includes(preferredLocale) ? preferredLocale : 'en-gb';
};
export const localeInit = () => {
    moment.locale(getClientPreferredLocale());
    momentTZ.locale(getClientPreferredLocale());
};
localeInit();
